import { render, staticRenderFns } from "./BingoTop.vue?vue&type=template&id=2504b3b4&scoped=true&"
import script from "./BingoTop.vue?vue&type=script&lang=ts&"
export * from "./BingoTop.vue?vue&type=script&lang=ts&"
import style0 from "./BingoTop.vue?vue&type=style&index=0&id=2504b3b4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2504b3b4",
  null
  
)

export default component.exports